import axios from 'axios'
import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import {
  getSharedNotes,
  saveData,
  sendClickToCall,
  sendEmailAndActivity,
  sendSharedNotes,
  setActivityInactiveFromModal,
} from './Redux/clickToCallActions'

import { ToggleButton } from 'primereact/togglebutton'
import { Button, Col, Label, Row } from 'reactstrap'

import { Dropdown } from 'primereact/dropdown'
import CustomEditor from '../../common/CustomEditor'
import CustomModal, { useModal } from '../../common/CustomModal/CustomModal'
import PopupModal from '../../common/CustomPopupModal/CustomPopupModal'
import CustomSelect from '../../common/CustomReactSelectComponent'
import { AddAttachment } from '../../common/FileAttachment/AddAttachment'
import { closeModal, setModal } from '../../common/GlobalModal/redux/GlobalModalActions'
import { EMAIL, INCOMING_CALL, MEETING, OUT_GOING_CALL, TEXT_MESSAGE } from '../../constants/activityTypes'
import { SHIPPERS } from '../../constants/contactCategory'
import { INSURANCE, LOGISTICS } from '../../constants/divisions'
import { ACTIVITY_FOLLOW_UP_NONE, DIRECT_MAIL_ACTIVITIES } from '../../constants/permissions'
import { ACCOUNT_STATUS, PENDING_STATUS, PROSPECT_STATUS } from '../../constants/statuses'
import { NONE } from '../../constants/taskConstants'
import { useFileAttachments } from '../../hooks/useFileAttachments'
import useGetSupportTable from '../../hooks/useGetSupportTable'
import { notificationDanger, notificationDangerCustomTime } from '../../utils/customToastify'
import { now } from '../../utils/utcTime'
import { updateCustomerLogistics } from '../CustomerLogistics/redux/customerLogisticsActions'
import { clearEventData, editEventData, getContactName, isTaskAssigned } from '../Task/Redux/taskActions'
import TimelineForActivity from './TimelineForActivity'
import { CustomInputNumber } from '../../common/CustomInputs/CustomInputs'
import InputGroup from '../../common/InputGroup'
import formData from 'form-data'
import ReactDatePicker from '../../common/ReactDatePicker/ReactDatePicker'
import { getUsersForCustomSelect, getUsersForCustomSelectByDivision } from '../Users/redux/userActions'
import { getDivisionsForCustomSelect } from '../Divisions/redux/DivisionActions'
import { changeExpenseData, clearExpenseData } from '../Expenses/redux/expenseActions'

const ACTIVITY_SUPPORT_TYPE_ID = 8
const NEXT_STEP_SUPPORT_TYPE_ID = 9

/**
 *
 * @property {bool} isActivityFromCall  flag for activity created for/from incoming call (component)
 *
 */
const CallModal = ({
  activityIdd,
  phoneCallDetails,
  sendClickToCall,
  userId,
  callback,
  defaultActivityType,
  activityTypeDisabled,
  sendEmailAndActivity,
  userPermissions,
  sendSharedNotes,
  saveData,
  getSharedNotes,
  setModal,
  closeModal,
  contactIdRedux,
  getContactName,
  divisionId,
  activityType,
  subjectTextProps,
  setActivityInactiveFromModal,
  startedCall,
  contactIdProps,
  customOnSaveActivity,
  isActivityFromCall,
  callId,
  contactIdForCall,
  contact,
  isLogisticsCustomer,
  updateCustomerLogistics,
  usersForCustomSelect,
  getUsersForCustomSelect,
  getUsersForCustomSelectByDivision,
  divisions,
  getDivisionsForCustomSelect,
  userDivision,
  editEventData,
  eventData,
  expenseData,
  changeExpenseData,
  reduxErrors,
}) => {
  const dispatch = useDispatch()
  let optionsActivityType = useGetSupportTable(ACTIVITY_SUPPORT_TYPE_ID)
  let optionsNextStep = useGetSupportTable(NEXT_STEP_SUPPORT_TYPE_ID)
  const [options, setOptions] = useState({ activityType: [], nextStep: [] })
  const [dueDate, setDueDate] = useState(new Date())
  const [selectedNextStep, setSelectedNextStep] = useState(0)
  const [errors, setErrors] = useState({})
  const [isNoteChecked, setIsNotChecked] = useState(false)
  const [isNoteDivisionOnly, setIsNoteDivisionOnly] = useState(false)
  const [subjectText, setSubjectText] = useState(subjectTextProps !== undefined ? subjectTextProps : 'Call')
  const [subjectDropdownText, setSubjectDropdownText] = useState(
    subjectTextProps !== undefined ? subjectTextProps : { name: 'Call', code: 'Call' }
  )
  const [division, setDivision] = useState(null)
  const [isReceiptUploaded, setIsReceiptUploaded] = useState(false)
  const [note, setNote] = useState()
  const [isHadDemo, setIsHadDemo] = useState(false)
  const [isRfp, setIsRfp] = useState(false)
  const [isMfp, setIsMfp] = useState(false)
  const [isOnlineForm, setIsOnlineForm] = useState(false)
  const [isCreditApp, setIsCreditApp] = useState(false)
  const [description, setDescription] = useState('')
  const [selectedActivityType, setSelectedActivityType] = useState(defaultActivityType || null)
  // The modal host reuses this component instance between openings (minimized modals stay
  // mounted), so the useState initialiser above only ever runs for the first activity logged.
  // Without this resync the type of the previous activity leaks into the next one - and when
  // the caller passes activityTypeDisabled the rep cannot even see the stale value.
  useEffect(() => {
    setSelectedActivityType(defaultActivityType || null)
  }, [defaultActivityType])
  const [noNextStepId, setNoNextStepId] = useState(null)
  const [hasAssigned, setHasAssigned] = useState(false)
  const [oldCrmNote, setOldCrmNote] = useState('')
  const [loader, setLoader] = useState(false)
  const [confirmSendEmailModal, setConfirmSendEmailModal] = useState(false)
  const { attachments, isMaxFilesExceeded, onUploadDocuments: onAttachmentUpload, List } = useFileAttachments()

  const { isModalOpen: isAddAttachmentModalOpen, toggleModal: toggleAddAttachmentModal } = useModal()

  useEffect(() => {
    if (divisionId === LOGISTICS || divisionId === INSURANCE) {
      setIsNotChecked(true)
    }
  }, [divisionId])

  const displayButton = useMemo(() => {
    return {
      rfp: isLogisticsCustomer && contact.contactDivisionData.statusId === PROSPECT_STATUS,
      mfp:
        isLogisticsCustomer &&
        [PROSPECT_STATUS, PENDING_STATUS, ACCOUNT_STATUS].includes(contact?.contactDivisionData?.statusId),
      onlineForm:
        isLogisticsCustomer &&
        [PROSPECT_STATUS, PENDING_STATUS, ACCOUNT_STATUS].includes(contact?.contactDivisionData?.statusId),
      creditApp:
        isLogisticsCustomer &&
        [PROSPECT_STATUS, PENDING_STATUS, ACCOUNT_STATUS].includes(contact?.contactDivisionData?.statusId),
    }
  }, [contact, isLogisticsCustomer])

  useEffect(() => {
    setIsRfp(contact.isRfp)
  }, [contact.isRfp])

  useEffect(() => {
    setIsMfp(contact.isMfp)
  }, [contact.isMfp])

  useEffect(() => {
    setIsCreditApp(contact.isCreditApp)
  }, [contact.isCreditApp])

  useEffect(() => {
    setIsOnlineForm(contact.isOnlineForm)
  }, [contact.isOnlineForm])

  useEffect(() => {
    if (reduxErrors) {
      setErrors((state) => ({ ...state, ...reduxErrors }))
    }
  }, [reduxErrors])

  useEffect(() => {
    getDivisionsForCustomSelect()
    getUsersForCustomSelect(userDivision, 'all')

    if (activityType === EMAIL) {
      setSubjectText('Send Email')
      setSubjectDropdownText({ name: 'Send Email', code: 'Send Email' })
    }

    if (activityType === INCOMING_CALL || defaultActivityType === INCOMING_CALL) {
      setSubjectText('Incoming Call')
      setSubjectDropdownText({ name: 'Incoming Call', code: 'Incoming Call' })
    }
  }, [])

  useEffect(() => {
    // if true fetch activities for contact opened from incoming calls component
    // else fetch activities for contact we're currently in
    if (isActivityFromCall && contactIdForCall) {
      getSharedNotes(contactIdForCall)
      hasAssignedTask(contactIdForCall)
    } else {
      const { customerId: contact_id } = phoneCallDetails
      getSharedNotes(contact_id || contactIdRedux || contactIdProps)
      hasAssignedTask(contact_id || contactIdProps)
    }
  }, [isActivityFromCall])

  useEffect(() => {
    if (!userPermissions.includes(DIRECT_MAIL_ACTIVITIES)) {
      optionsActivityType = optionsActivityType.filter((i) => i.name !== 'Direct Mail')
    }
    if (!userPermissions.includes(ACTIVITY_FOLLOW_UP_NONE)) {
      optionsNextStep = optionsNextStep.filter((i) => i.name !== 'None')
    }
    setOptions({ activityType: optionsActivityType, nextStep: optionsNextStep })
  }, [optionsActivityType, optionsNextStep])

  useEffect(() => {
    if (options?.nextStep?.length > 0 && !noNextStepId) {
      const noNextStep = options.nextStep.find((e) => e.name === 'None')
      if (noNextStep) {
        setNoNextStepId(noNextStep.id)
      }
    }
  }, [options.nextStep])

  const hasAssignedTask = async (contactId) => {
    const hasAssigned = await isTaskAssigned(userId, contactId || contactIdRedux || contactIdProps)
    setHasAssigned(!!hasAssigned.length)
  }

  const handleChangeEmailBody = (e) => {
    const oldCrmValue = e.textValue
    let val = e.htmlValue
    setOldCrmNote(oldCrmValue)
    setNote(val)
    setDescription(val)
    setErrors({ ...errors, note: undefined })
  }

  const handleChange = async (e) => {
    const NO_ANSWER = 10001
    const FOLLOW_UP_TOMORROW = 10003
    const NEXT_WEEK = 10004
    const PER_POLICY = 10002

    if (PER_POLICY === e.id) {
      const response = await axios(`/system-config/get-by-division/${divisionId}`)
      setDueDate(
        moment()
          .add(response.data.startAFollowUp, 'days')
          .set({ hour: 17, minute: 0, second: 0 })
          .format('YYYY-MM-DD HH:mm')
      )
    }
    if (NO_ANSWER === e.id) {
      const response = await axios('/system-config/null')

      setDueDate(moment().add(response.data.noAnswerCall, 'minutes').format('YYYY-MM-DD HH:mm'))
    }
    if (FOLLOW_UP_TOMORROW === e.id) {
      setDueDate(moment().add(1, 'days').set({ hour: 17, minute: 0, second: 0 }).format('YYYY-MM-DD HH:mm'))
    }
    if (NEXT_WEEK === e.id) {
      setDueDate(moment().add(7, 'days').set({ hour: 17, minute: 0, second: 0 }).format('YYYY-MM-DD HH:mm'))
    }
    setSelectedNextStep(e.id)

    setErrors({ ...errors, nextStep: undefined })
  }

  const handleChangeActivityType = (e) => {
    if (e.id === OUT_GOING_CALL) {
      setSubjectDropdownText('Call')
      setSubjectText('Call')
    } else if (e.id === TEXT_MESSAGE) {
      setSubjectDropdownText('Send Text')
      setSubjectText('Send Text')
    } else if (e.id === EMAIL) {
      setSubjectDropdownText('Send Email')
      setSubjectText('Send Email')
    } else if (e.id === INCOMING_CALL) {
      setSubjectDropdownText('Incoming Call')
      setSubjectText('Incoming Call')
    } else if (e.id === MEETING) {
      setSubjectText('Meeting')
      setSubjectDropdownText('Meeting')
    }
    setSelectedActivityType(e.id)
  }

  const toggleConfirmSendEmailModal = () => {
    setConfirmSendEmailModal((p) => !p)
  }

  const sendEmail = async (e) => {
    const { customerId: contact_id } = phoneCallDetails
    const normalizedContactId = isActivityFromCall ? contactIdForCall : contact_id || contactIdRedux || contactIdProps
    setLoader(true)
    e.preventDefault()

    let newErrors = { ...errors }
    if (!selectedNextStep || selectedNextStep === 0 || !note) {
      if (!selectedNextStep || selectedNextStep === 0) {
        newErrors = { ...newErrors, nextStep: 'required' }
      }
      if (!note) {
        newErrors = { ...newErrors, note: 'nte' }
        notificationDanger('Please Enter Note')
      }
      setErrors(newErrors)
      setLoader(false)
      return
    }
    const dataForActivity = {
      nextStepId: selectedNextStep,
      subject: subjectText,
      notes: description,
      activityType: selectedActivityType,
      contact_id: normalizedContactId,
      isDemo: isHadDemo,
      creationDate: now(),
    }

    try {
      const res = await sendEmailAndActivity(dataForActivity, attachments)

      closeModal('clickToCall')
      const dataForSendToTaskEdit = {
        selectedNextStep,
        title: subjectText,
        description,
        selectedActivityType,
        contact_id: normalizedContactId,
        isDemo: isHadDemo,
      }
      const contactName = await getContactName(normalizedContactId)
      if (selectedNextStep !== noNextStepId) {
        setModal({
          id: 'task_modal',
          name: `Task Edit ${contactName.name}`,
          props: {
            contactIdTask: normalizedContactId,
            dataFromActivityWhenSendEmail: {
              ...dataForSendToTaskEdit,
              activityId: activityIdd || res[0] ? res[0].id : null,
            },
            dataFromActivity: null,
            fromActivity: true,
          },
        })
      } else {
        customOnSaveActivity && customOnSaveActivity()
      }
    } finally {
      // keep the buttons usable so the user can fix the input and retry;
      // the request error itself is surfaced by the global axios handler
      setLoader(false)
    }
  }

  const saveCall = async (e) => {
    setLoader(true)
    e.preventDefault()
    if (startedCall && !activityIdd) {
      notificationDangerCustomTime('You cannot create activity before call is started', 10000)
      setLoader(false)
      return
    }
    let newErrors = { ...errors }
    if (!selectedNextStep || selectedNextStep === 0 || !note) {
      if (!selectedNextStep || selectedNextStep === 0) {
        newErrors = { ...newErrors, nextStep: 'required' }
      }
      if (!note) {
        newErrors = { ...newErrors, note: 'nte' }
        notificationDanger('Please Enter Note')
      }
      setErrors(newErrors)
      setLoader(false)
      return
    }
    const { time, customerId: contact_id, celler_id } = phoneCallDetails
    const normalizedContactId = isActivityFromCall ? contactIdForCall : contact_id || contactIdRedux || contactIdProps
    const duration = now() - time
    const durationInSec = Math.ceil(duration / 1000)
    const dataForActivity = {
      selectedNextStep,
      isNoteChecked,
      title: subjectText,
      description,
      selectedActivityType,
      contact_id: normalizedContactId,
      dueDate,
      activityTypeOptions: options.activityType,
      isDemo: isHadDemo,
      linkCallWithActivity: {
        isActivityFromCall,
        callId,
        contactId: contactIdForCall,
      },
      division,
    }

    try {
      const res = await sendClickToCall(
        {
          activity_id: activityIdd,
          contact_id: normalizedContactId,
          call_number: celler_id,
          user_id: userId,
          end_time: now(),
          creation_date: time,
          duration: durationInSec,
          eventData: {
            ...eventData,
            meetingStart: moment(eventData.meetingStart, 'MM/DD/YYYY hh:mm a').utc().toISOString(),
            meetingEnd: moment(eventData.meetingEnd, 'MM/DD/YYYY hh:mm a').utc().toISOString(),
          },
          expenseData,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        dataForActivity,
        attachments,
        callback
      )

      saveData({ ...dataForActivity, activityId: activityIdd || res })

      const newActivityId = activityIdd || res

      if (isNoteChecked) {
        sendSharedNotes(
          {
            note: description,
            subject: subjectText,
            contact_id: normalizedContactId,
            oldCrmNote,
            isDivisionOnly: isNoteDivisionOnly,
          },
          attachments?.length ? newActivityId : null // link shared notes with attachments if there are any
        )
      }

      if (isLogisticsCustomer && contact.isRfp !== isRfp) {
        updateCustomerLogistics(contact.id, divisionId, { ...contact, isRfp })
      }

      if (isLogisticsCustomer && contact.isMfp !== isMfp) {
        updateCustomerLogistics(contact.id, divisionId, { ...contact, isMfp })
      }

      if (isLogisticsCustomer && contact.isCreditApp !== isCreditApp) {
        updateCustomerLogistics(contact.id, divisionId, { ...contact, isCreditApp })
      }

      if (isLogisticsCustomer && contact.isOnlineForm !== isOnlineForm) {
        updateCustomerLogistics(contact.id, divisionId, { ...contact, isOnlineForm })
      }

      closeModal('clickToCall')
      const contactName = await getContactName(normalizedContactId)

      if (selectedNextStep !== noNextStepId) {
        setModal({
          id: 'task_modal',
          name: `Task Edit ${contactName.name}`,
          props: {
            contactIdTask: normalizedContactId,
            dataFromActivity: { ...dataForActivity, activityId: activityIdd || res },
            dataFromActivityWhenSendEmail: null,
            fromActivity: true,
            customOnSaveTask: customOnSaveActivity,
          },
        })
      } else {
        customOnSaveActivity && customOnSaveActivity()
      }
      dispatch(clearEventData())
      dispatch(clearExpenseData())
    } finally {
      // keep the buttons usable so the user can fix the input and retry;
      // the request error itself is surfaced by the global axios handler
      setLoader(false)
    }
  }

  const cancelClick = () => {
    setActivityInactiveFromModal()
    closeModal('clickToCall')
    setErrors({})
  }

  const activityDropdownOptions = [
    { name: 'Call', code: 'Call' },
    { name: 'Send Email', code: 'Send Email' },
    { name: 'Send Text', code: 'Send Text' },
    { name: 'Incoming Call', code: 'Incoming Call' },
  ]

  const changeSubject = (e) => {
    setSubjectDropdownText(e.value)
    if (typeof e.value === 'object') {
      setSubjectText(e.value.code)
    } else {
      setSubjectText(e.value)
    }
  }

  const onUploadDocuments = (data) => {
    toggleAddAttachmentModal()
    onAttachmentUpload(data)
  }

  const onSelectFile = async (e) => {
    const form = new formData()
    form.append('receipt', e.target.files[0])
    const response = await axios({
      method: 'post',
      url: '/expenses/upload-receipt',
      data: form,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    })
    setIsReceiptUploaded(true)
    changeExpenseData('receiptUrl', response.data.location)
    changeExpenseData('receiptKey', response.data.key)
  }

  const handleChangeEventDate = (date, name) => {
    const value = date ? moment(date).format('MM/DD/YYYY hh:mm a') : ''
    editEventData(name, value)
    setErrors((state) => ({ ...state, [name]: '' }))
  }

  const handleChangeDivision = ({ id }) => {
    if (!id) {
      getUsersForCustomSelect(1, 'all')
      setDivision(id)
      return
    }
    getUsersForCustomSelectByDivision(id, 'true')
    setDivision(id)
  }

  const handleChangeEventData = (e) => {
    const { name, value } = e.target
    editEventData(name, value)
  }

  const handleChangeSelectEventData = (values, name) => {
    const selectedAttendees = []
    if (values) {
      values.forEach((i) => {
        selectedAttendees.push(i.id || i.value)
      })
    }

    editEventData(name, selectedAttendees)
  }

  return (
    <>
      <CustomModal
        isOpen={isAddAttachmentModalOpen}
        toggle={toggleAddAttachmentModal}
        headerText='Add Attachment'
        showCloseButton
      >
        <AddAttachment onUploadDocuments={onUploadDocuments} multiple />
      </CustomModal>
      <Row>
        <Col xs={12} md={8} lg={8} className='mt-3'>
          <Row>
            <Col xs={12} md={12} lg={12} className='mt-3'>
              <Label>Subject</Label>
              <Dropdown
                value={subjectDropdownText}
                options={activityDropdownOptions}
                placeholder='Subject'
                onChange={changeSubject}
                optionLabel='name'
                editable
                className='custom-dropdown'
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={6} className='mt-3'>
              <CustomSelect
                isMulti={false}
                label='Activity Type'
                placeholder='Activity Type'
                disabled={activityTypeDisabled}
                onChange={handleChangeActivityType}
                defaultValue={selectedActivityType}
                options={options.activityType}
              />
            </Col>
            <Col xs={12} md={6} lg={6} className='mt-3'>
              <CustomSelect
                isMulti={false}
                label='Next Step'
                placeholder='Next Step'
                onChange={(e) => handleChange(e)}
                defaultValue={selectedNextStep}
                options={options.nextStep}
                errorMess={errors && errors.nextStep}
                invalid={errors && errors.nextStep}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={4} lg={4} className='mt-3'>
          <Row>
            {displayButton.rfp && (
              <Col xs={6} className='mt-3'>
                <div className='text-center'>
                  <Label>RFP</Label>
                  <div>
                    <ToggleButton checked={isRfp} onChange={() => setIsRfp((prev) => !prev)} />
                  </div>
                </div>
              </Col>
            )}
            {displayButton.mfp && (
              <Col xs={6} className='mt-3'>
                <div className='text-center'>
                  <Label>Mexico Freight</Label>
                  <div>
                    <ToggleButton checked={isMfp} onChange={() => setIsMfp((prev) => !prev)} />
                  </div>
                </div>
              </Col>
            )}
            {displayButton.creditApp && (
              <Col xs={6} className='mt-3'>
                <div className='text-center'>
                  <Label>Credit App</Label>
                  <div>
                    <ToggleButton checked={isCreditApp} onChange={() => setIsCreditApp((prev) => !prev)} />
                  </div>
                </div>
              </Col>
            )}
            {displayButton.onlineForm && (
              <Col xs={6} className='mt-3'>
                <div className='text-center'>
                  <Label>Online Form</Label>
                  <div>
                    <ToggleButton checked={isOnlineForm} onChange={() => setIsOnlineForm((prev) => !prev)} />
                  </div>
                </div>
              </Col>
            )}
            <Col xs={6} className='mt-3'>
              <div className='text-center'>
                <Label>Had Demo</Label>
                <div>
                  <ToggleButton checked={isHadDemo} onChange={() => setIsHadDemo(!isHadDemo)} />
                </div>
              </div>
            </Col>
            <Col xs={6} className='mt-3'>
              <div className='text-center'>
                <Label>Shared Notes</Label>
                <div>
                  <ToggleButton checked={isNoteChecked} onChange={() => setIsNotChecked(!isNoteChecked)} />
                </div>
                {/* Only meaningful once a note is actually being written, so it follows that toggle. */}
                {isNoteChecked && (
                  <div className='mt-2'>
                    <Label>Division only</Label>
                    <div>
                      <ToggleButton
                        checked={isNoteDivisionOnly}
                        onChange={() => setIsNoteDivisionOnly(!isNoteDivisionOnly)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {selectedActivityType === MEETING && (
        <>
          <Row className='mt-3'>
            <Col xs='12' md='3'>
              <InputGroup
                label='Location'
                name='location'
                value={eventData.location}
                onChange={(e) => handleChangeEventData(e)}
              />
            </Col>
            <Col xs='12' md='3'>
              <CustomInputNumber
                label='Expense'
                name='expense'
                mode='currency'
                minFractionDigits={2}
                maxFractionDigits={2}
                currency='USD'
                value={expenseData.expense}
                onChange={(e) => changeExpenseData('expense', e.target.value)}
                placeholder='0'
              />
            </Col>
            <Col xs='12' md='4'>
              <InputGroup
                onChange={onSelectFile}
                value={null}
                name='receipt'
                label='Upload Receipt'
                type='file'
                placeholder=''
                className='tesk-file-button'
              />
            </Col>
            <Col md='2 d-flex align-items-end'>
              {isReceiptUploaded && (
                <p className='text-success'>
                  <i className='fas fa-check'></i> Uploaded
                </p>
              )}
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col xs={12} md={3} lg={3}>
              <ReactDatePicker
                selected={eventData.meetingStart ? new Date(eventData.meetingStart) : ''}
                errorMess={errors.meetingStart ? errors.meetingStart : ''}
                onChange={(date) => handleChangeEventDate(date, 'meetingStart')}
                label='Meeting Start Date/Time'
                showTimeSelect
                showTimeInput
                isClearable
                allowedDates={[
                  moment().startOf('day'),
                  moment().subtract(1, 'day').startOf('day'),
                  moment().subtract(2, 'day').startOf('day'),
                ]}
              />
            </Col>
            <Col xs={12} md={3} lg={3}>
              <ReactDatePicker
                selected={eventData.meetingEnd ? new Date(eventData.meetingEnd) : ''}
                errorMess={errors.meetingEnd ? errors.meetingEnd : ''}
                onChange={(date) => handleChangeEventDate(date, 'meetingEnd')}
                label='Meeting End Date/Time'
                showTimeSelect
                showTimeInput
                isClearable
                allowedDates={[
                  moment().startOf('day'),
                  moment().subtract(1, 'day').startOf('day'),
                  moment().subtract(2, 'day').startOf('day'),
                ]}
              />
            </Col>
            <Col xs={12} md={3} lg={3}>
              <CustomSelect
                isMulti
                label='Attendees'
                placeholder='Attendees'
                onChange={(e) => handleChangeSelectEventData(e, 'attendees')}
                defaultValue={eventData.attendees || []}
                options={usersForCustomSelect || []}
              />
            </Col>
            <Col xs={12} md={3} lg={3}>
              <CustomSelect
                isMulti={false}
                label='Divisions'
                placeholder='Divisions'
                onChange={(e) => handleChangeDivision(e)}
                defaultValue={division}
                options={[{ name: 'All', id: null }, ...divisions]}
              />
            </Col>
          </Row>
        </>
      )}
      <Row className='mt-3'>
        <Col xs={12} md={12} lg={12}>
          <CustomEditor
            disableAttachmentButton={isMaxFilesExceeded}
            addAttachmentClick={toggleAddAttachmentModal}
            name='emailBody'
            onChange={handleChangeEmailBody}
            // value={email.body}
            height='250px'
            customStyle={{ backgroundColor: 'none' }}
          />
        </Col>
      </Row>
      <Row>
        <Col>{List}</Col>
      </Row>
      {hasAssigned && (
        <Row className='mt-3'>
          <Col className='text-right'>
            <span className='text-danger'>This user already has task assigned for this contact</span>
          </Col>
        </Row>
      )}

      <Row className='mt-3'>
        <Col className='text-left'>
          <Button className={'btn btn-gold btn-sm'} onClick={cancelClick}>
            Cancel
          </Button>
        </Col>

        <Col className='text-right'>
          <Button
            className={'btn btn-gold btn-sm mr-3'}
            onClick={saveCall}
            disabled={(hasAssigned && selectedNextStep !== NONE) || loader}
          >
            Ok
          </Button>
          {divisionId !== LOGISTICS && (
            <Button
              className={'btn btn-gold btn-sm'}
              onClick={toggleConfirmSendEmailModal}
              disabled={(hasAssigned && selectedNextStep !== NONE) || loader}
            >
              Send Email
            </Button>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <TimelineForActivity
            contactId={
              isActivityFromCall ? contactIdForCall : phoneCallDetails.customerId || contactIdRedux || contactIdProps
            }
            showFilters
          />
        </Col>
      </Row>
      <PopupModal
        headerText='Confirm Sending Email'
        isOpen={confirmSendEmailModal}
        toggle={toggleConfirmSendEmailModal}
        className='modal-warning'
        buttons={[
          {
            block: false,
            color: 'warning',
            text: 'Yes',
            onClick: (e) => {
              sendEmail(e)
              toggleConfirmSendEmailModal()
            },
          },
          {
            block: false,
            color: 'primary',
            text: 'No',
            onClick: toggleConfirmSendEmailModal,
          },
        ]}
      >
        <p>
          <strong>Alert! You are sending direct email to Contact.</strong>
        </p>
        <p>
          <strong>Please verity Subject and Notes!</strong>
        </p>
        <p>
          <strong>Are you sure you wish to proceed with email sending?</strong>
        </p>
      </PopupModal>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    phoneCallDetails: state.ClickToCall.phoneCallDetails,
    userId: state.auth.user.userId,
    divisionId: state.auth.user.division_id,
    userPermissions: state.auth.user.permissions,
    contactIdRedux: state.contacts.contact.id,
    activityIdd: state.ClickToCall.activityId,
    contact: state.contacts.contact,
    isLogisticsCustomer:
      state.auth.user.division_id === LOGISTICS && state.contacts.contact.contactCategory === SHIPPERS,
    usersForCustomSelect: state.users.usersForCustomSelect,
    divisions: state.divisions.divisionForSelect,
    userDivision: state.auth.user.division_id,
    eventData: state.Task.eventData,
    expenseData: state.Expenses.expense,
    reduxErrors: state.errors,
  }
}

export default connect(mapStateToProps, {
  sendClickToCall,
  saveData,
  sendSharedNotes,
  getSharedNotes,
  setModal,
  sendEmailAndActivity,
  closeModal,
  getContactName,
  setActivityInactiveFromModal,
  updateCustomerLogistics,
  getUsersForCustomSelect,
  getUsersForCustomSelectByDivision,
  getDivisionsForCustomSelect,
  editEventData,
  changeExpenseData,
})(CallModal)
